import CreateItemResponse from "../types/CreateItemResponse";
import axiosInstance from "./axiosInstance";
import NameRequest from "../types/NameRequest";
import EntitiesResponse from "../types/EntitiesResponse";

export const postProduct = async (request: NameRequest): Promise<CreateItemResponse | void> => {
    return axiosInstance.post<CreateItemResponse>("/products", request)
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const fetchProducts = async (): Promise<EntitiesResponse | void> => {
    return axiosInstance.get<EntitiesResponse>("/products")
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const deleteProduct = async (id: number): Promise<void> =>
    axiosInstance.delete<void>(`/products/${id}`)
        .then(response => response.data)
        .catch(error => error.response.data)
